module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAA9klEQVRYR2Nc4mB9Sp2NRZCBBCBgZcslGR4puO3KM+YJB26ywLQG68v8TbdV/fNmz87Przdv/ESCkWQpvf3n3zvGE662ZyRZWIxJMYHb1YNBuLCMYc6Ocwypk7bAtRYGWDD0pbkxfFy2iOHjkgWkGEmW2hd//p0d9cBoDJCVeCCaRpPQaCamIPmMJqHReoDC5DN8ktDHc2ff8xkaCZATILhKIXLMIkfPhxPH3zMOeQ+45U//tevWK1ZyQmCg9fhpiv9iHPXAAEbD8IiBIZ+Jh7wHRruUo31i8oux0R7ZaI+M/NQz2qkfHZmjMPWMJqHBk4SG+vA6AP1uCS22Y+x/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c144.png
// module id = am9Z
// module chunks = 18